import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Contact } from '../../crm/models/contact.model';

import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const loadContacts = createAction('[Contact] Load Contacts');

export const loadMoreContacts = createAction(
  '[Contact] Load More Contacts',

  props<{ limit?: number; offset?: number }>(),
);
export const cancelLoadContacts = createAction(
  '[Contact] Cancel Load Contacts',
);
export const loadMoreContactsSuccess = createAction(
  '[Contact] Load More Contacts Success',

  props<{
    contactList: Contact[];
    total?: number;
    current?: number;
  }>(),
);

export const selectContact = createAction(
  '[Contact] Select Contact',

  props<{ id: number }>(),
);

export const loadContactsSuccess = createAction(
  '[Contact] Load Contacts Success',

  props<{ contacts: Contact[] }>(),
);

export type DialogActions = 'continue' | 'close' | 'idle';

export const addContact = createAction(
  '[Contact] Add Contact',

  props<{
    contact: Contact;
    action?: DialogActions;
  }>(),
);

export const addContactSuccess = createAction(
  '[Contact] Add Contact Success',

  props<{ contact: Contact }>(),
);

export const upsertContact = createAction(
  '[Contact] Upsert Contact',

  props<{ contact: Contact }>(),
);

export const addContacts = createAction(
  '[Contact] Add Contacts',

  props<{ contacts: Contact[] }>(),
);

export const upsertContacts = createAction(
  '[Contact] Upsert Contacts',

  props<{ contacts: Contact[] }>(),
);

export const updateContact = createAction(
  '[Contact] Update Contact',

  props<{ contact: Contact; id: number }>(),
);

export const updateContactSuccess = createAction(
  '[Contact] Update Contact Success',

  props<{ contact: Update<Contact> }>(),
);

export const updateContacts = createAction(
  '[Contact] Update Contacts',

  props<{ contacts: Update<Contact>[] }>(),
);

export const updateContactsSuccess = createAction(
  '[Contact] Update Contacts Success',

  props<{ contacts: Update<Contact>[] }>(),
);
export const deleteContact = createAction(
  '[Contact] Delete Contact',

  props<{ id: string }>(),
);

export const deleteContactSuccess = createAction(
  '[Contact] Delete Contact Success',

  props<{ id: string }>(),
);

export const contactError = createAction(
  '[Contact] Contact error',

  props<{ err: any }>(),
);

export const setContactSearch = createAction(
  '[Contact] Set Contact Search',

  props<{ search: string }>(),
);
export const setContactSort = createAction(
  '[CRM] Set Contact Sort',
  props<{ sortBy: SortBy }>(),
);
export const resetContactFilters = createAction('[Contact] Reset Filters');
export const clearContacts = createAction('[Contact] Clear Contacts');
